module.exports = __webpack_public_path__ + "static/media/chat_button_icon_active_mobile.c886a1a8.svg";